import type { Feature } from "@/api/models"

/** Check a feature flag from config (non-hook — safe in route builders). */
export function isFeatureEnabledInConfig(
  features: Feature[] | undefined,
  featureId: string
): boolean {
  return features?.some((f) => f.id === featureId && f.enabled) ?? false
}

/** Read a feature's config from config (non-hook — safe in route builders).
 *  Returns undefined when the feature is missing, disabled, or has no config,
 *  so callers can treat "no config" as "use hardcoded defaults" uniformly
 *  with the flag-off behavior. */
export function getFeatureConfig<T = Record<string, unknown>>(
  features: Feature[] | undefined,
  featureId: string
): T | undefined {
  const feature = features?.find((f) => f.id === featureId && f.enabled)
  return feature?.config as T | undefined
}

/**
 * Hosted agents are offered on this deployment (non-hook — safe in route
 * builders). The backend reports `hostedAgentsEnabled` from its
 * `HOSTED_AGENTS_ENABLED` switch; anything but an explicit `true` — an older
 * backend, a missing key, a config not loaded yet — reads as off, so an Azure
 * customer never sees the Agents module, its admin sections or its invoice.
 */
export function isHostedAgentsEnabledInConfig(
  config: { hostedAgentsEnabled?: unknown } | null | undefined
): boolean {
  return config?.hostedAgentsEnabled === true
}
